module.exports = __webpack_public_path__ + "media/images/d_4-4fc5baddb124831ba41aba13f93cc57b.png";